import {Card, ListGroup } from 'react-bootstrap'
import { FaMapMarkerAlt, FaPhoneAlt, FaAt   } from "react-icons/fa";

const AboutMe = () => {

    const yr = new Date().getFullYear() - 2004;
    const yr2 = new Date().getFullYear() - 2010;
    const yr3 = new Date().getFullYear() - 2020;

    return (
      <>
        <Card className="customCard" border='primary'>
            <Card.Header>About Me</Card.Header>        
            <Card.Body>
                <ListGroup className="list-group-flush">
                    <ListGroup.Item>Versatile and creative senior software engineer with {yr} years of experience participating in all project lifecycle phases in various Agile or Waterfall environments. Recently developed a PHP web application for tracking and reporting children and sponsors for a non-profit organization. Proficient with Windows and Web applications. <br/><br/>
                    With {yr2} years of experience with video editing using Premiere and After Effects, vector using Illustrator, photo editing using Photoshop. <br/><br/>
                    With {yr3} years of experience in live streaming software such as OBS, and Propresenter 7.
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <FaMapMarkerAlt /> <b>Location</b><br/>
                        Blk 1 Lot 27 La Teraza Phase B,<br/>
                        Bucandala, City of Imus, Cavite<br/>
                        4103 Philippines
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <FaPhoneAlt /> <b>Mobile Number(s)</b><br/>
                        (+63) 925 803 4389<br/>
                        (+63) 927 655 5325
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <FaAt /> <b>Email address(es)</b><br/>
                        puppz03@gmail.com<br/>
                        prov2427_pupz@yahoo.com.ph
                    </ListGroup.Item>
                </ListGroup>
            </Card.Body>
        </Card>
      </>
    );
}

export default AboutMe;